module.exports = __webpack_public_path__ + "img/logo-brand-kami.f27a9ae6.png";